import { FC } from 'react';
// components
import AccessDenied from 'components/AccessDenied';
// helper, interfaces, context
import { isAdminOrSuperAdmin } from 'lib/helper';
import { ChildrenType } from 'interfaces';
import { useAuthContext } from 'contexts/AuthContext';

export const SuperOrAdminGuard: FC<ChildrenType> = ({ children }) => {
  const { userRoles } = useAuthContext();

  const isSuper = isAdminOrSuperAdmin(userRoles);

  return <>{isSuper ? children : <AccessDenied />}</>;
};
